var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 3.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 3.75,
    stroke: "#173C19",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.71 27.29L25.31 23.9C26.407 22.5025 27.0022 20.7767 27 19C27 17.4178 26.5308 15.871 25.6518 14.5554C24.7727 13.2398 23.5233 12.2145 22.0615 11.609C20.5997 11.0035 18.9911 10.845 17.4393 11.1537C15.8874 11.4624 14.462 12.2243 13.3431 13.3431C12.2243 14.462 11.4624 15.8874 11.1537 17.4393C10.845 18.9911 11.0035 20.5997 11.609 22.0615C12.2145 23.5233 13.2398 24.7727 14.5554 25.6518C15.871 26.5308 17.4178 27 19 27C20.7767 27.0022 22.5025 26.407 23.9 25.31L27.29 28.71C27.383 28.8037 27.4936 28.8781 27.6154 28.9289C27.7373 28.9797 27.868 29.0058 28 29.0058C28.132 29.0058 28.2627 28.9797 28.3846 28.9289C28.5064 28.8781 28.617 28.8037 28.71 28.71C28.8037 28.617 28.8781 28.5064 28.9289 28.3846C28.9797 28.2627 29.0058 28.132 29.0058 28C29.0058 27.868 28.9797 27.7373 28.9289 27.6154C28.8781 27.4936 28.8037 27.383 28.71 27.29ZM13 19C13 17.8133 13.3519 16.6533 14.0112 15.6666C14.6705 14.6799 15.6075 13.9109 16.7039 13.4567C17.8003 13.0026 19.0067 12.8838 20.1705 13.1153C21.3344 13.3468 22.4035 13.9182 23.2426 14.7574C24.0818 15.5965 24.6532 16.6656 24.8847 17.8295C25.1162 18.9933 24.9974 20.1997 24.5433 21.2961C24.0892 22.3925 23.3201 23.3295 22.3334 23.9888C21.3467 24.6481 20.1867 25 19 25C17.4087 25 15.8826 24.3679 14.7574 23.2426C13.6321 22.1174 13 20.5913 13 19Z",
    fill: "#173C19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.426019b464486d98692c6fadfe59a7f0.svg";
export { ForwardRef as ReactComponent };